<template>
  <b-row>
    <b-col>
      <b-form
        class="card m-0"
        :class="{ 'was-validated' : wasSubmitted }"
        @submit.prevent="onSubmit"
        data-test="form"
      >
        <div class="card-body">
          <slot />
        </div>
        <div class="card-footer d-flex justify-content-between flex-row-reverse">
          <b-button
            type="submit"
            variant="primary"
            :class="{ 'btn-loading': isLoading }"
            :disabled="!isValid"
            @click="onClick"
            data-test="submit-button"
          >
            {{ buttonText }}
            <i class="fas fa-arrow-right" />
          </b-button>
          <b-button
            type="button"
            variant="secondary"
            @click="goBack"
            data-test="back-button"
          >
            <i class="fas fa-arrow-left" />
            Back
          </b-button>
        </div>
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'BaseFormCard',

  props: {
    buttonText: {
      type: String,
      default: 'Save',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isValid: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      wasSubmitted: false,
    };
  },

  methods: {
    goBack() {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.replace(window.document.referrer);
      }
    },

    onSubmit() {
      this.$emit('submit');
    },

    onClick() {
      this.wasSubmitted = true;
      this.$emit('validate');
    },
  },
};
</script>
